import { TFunction } from 'i18next';

export type AnalyzerCategory = "trip" | "airport" | "booking" | "bonus" | "misc" | "tips" | "distance_km" | "rides_fee"

export interface LineItem {
  category: AnalyzerCategory;
  amount: number;
  description: string;
}

export interface IncomeDocument {
  reference: {
    date: string;
    type: string;
    number: string;
  }
  line_items: LineItem[];
}

export type TripLineItem = {
  reference: string
  date: string
  amount: number
}

export type IncomeParentCategory = "trip" | "bonus" | "tips" | "uber_trip" | "uber_bonus" | "uber_tips" | "other"

export type IncomeErrors = {
  reference?: string[]
}

export const getParentCategories = (t: TFunction) => [
  { value: 'other', label: t('income.categories.other'), description: t('income.categories.other') },
  { value: 'trip', label: t('common.tripIncome'), description: t('common.tripIncome') + ' (Bolt)' },
  { value: 'bonus', label: t('common.bonus'), description: t('common.bonus') + ' (Bolt)' },
  { value: 'tips', label: t('common.tips'), description: t('common.tips') + ' (Bolt)' },
  { value: 'uber_trip', label: t('common.tripIncome'), description: t('common.tripIncome') + ' (Uber)' },
  { value: 'uber_bonus', label: t('common.bonus'), description: t('common.bonus') + ' (Uber)' },
  { value: 'uber_tips', label: t('common.tips'), description: t('common.tips') + ' (Uber)' }
]